<template>
  <scrollable-container>
    <tabset :tabs="tabs" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </scrollable-container>
</template>

<script>
import Tabset from '@/components/common/tabs/tabset.vue';
import ScrollableContainer from '@/components/common/blocks/scrollable-container.vue';

export default {
  components: {
    Tabset,
    ScrollableContainer,
  },
  data() {
    return {
      tabs: [
        {
          title: this.$t('reports.printStatisticsByDocuments'),
          route: './docStat',
        },
        {
          title: this.$t('reports.printStatisticsByPrinters'),
          route: './printStat',
          sortVariableName: 'PrintStatSortState',
        },
        {
          title: this.$t('reports.printStatisticsByUsers'),
          route: './userStat',
        },
      ],
    };
  },
};
</script>
